import { put, all, takeLatest, select } from 'redux-saga/effects';
import actions, { apiActions } from './actions';
import { authTokenSelector } from '../session';

export function* getSuburbs(action) {
  const authToken = yield select(authTokenSelector);
  yield put(apiActions.geonames.suburbs.get(authToken, action.payload.query));
}

function* geonamesSagas() {
  yield all([
    takeLatest(actions.geonames.suburbs.get().type, getSuburbs)
  ]);
}

export default geonamesSagas;



// WEBPACK FOOTER //
// ./src/state/modules/geonames/sagas.js